module.exports = __webpack_public_path__ + "static/img/txt.29fd1281.png";